
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full Name List of "Shiv" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full Name List of "Shiv" in both Marathi and English, with an option to switch between the two languages.'
           },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: '108 names of Shiva, Shiv Namavali in Sanskrit, Shiv Namavali with meanings, Lord Shiva names chanting, Shiva names for puja, Shiv Namavali, Lord Shiva mantras'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'108 names of Shiva, Shiv Namavali in Sanskrit, Shiv Namavali with meanings, Lord Shiva names chanting, Shiva names for puja, Shiv Namavali, Lord Shiva mantras, 108 names of Lord Shiva list, शिव 108 नामावली, शिव 108 नामावली marathi, Names of Shiv'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/namavali/shiv.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/namavali/shiv.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Shiv 108 Namavali | 108 Namavali - शिव 108 नामावली(108 नामावली)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
  
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/namavali/shiv"
        },
        "headline": "Shiv 108 Namavali - शिव 108 नामावली(108 नामावली)",
        "name" : "Shiv 108 Namavali - 108 Namavali",
        "description": "Explore the full Name List of 'Shiv' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/namavali/shiv.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  